import request from "@/utils/request";
import config from "@/utils/config";
import {
	handleUrlEncode
} from "@/utils/urlutil"

/**
 * 后台积分规则添加
 * @param {Object} param
 */
export function addCreditRule(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminCreditRule/Add",
		method: "post",
		data,
	});
}

/**
 * 后台积分规则映射添加
 * @param {Object} param
 */
export function addCreditRuleMap(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminCreditRule/CreditRuleMap/Add",
		method: "post",
		data,
	});
}

/**
 * 后台积分规则映射删除
 * @param {Object} param
 */
export function deleteCreditRuleMap(param) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminCreditRule/CreditRuleMap/Delete",
		method: "delete",
		params: param,
	});
}

/**
 * 后台分页获取积分规则映射集合
 * @param {Object} param
 */
export function getCreditRuleMapList(param) {
	let url = ''
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminCreditRule/CreditRuleMap/List",
		method: "get",
		params: param,
	});
}

/**
 * 后台积分规则映射更新
 * @data {Object} data
 */
export function updateCreditRuleMap(data) {
	let url = ''
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminCreditRule/CreditRuleMap/Update",
		method: "post",
		data,
	});
}

/**
 * 后台积分规则删除或者恢复
 * @param {Object} param
 */
export function creditRuleDeleteOrBack(param) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminCreditRule/DeleteOrBack",
		method: "delete",
		params: param,
	});
}

/**
 * 后台分页获取积分规则集合
 * @param {Object} param
 */
export function getCreditRuleList(param) {
	let url = config.API_ADMIN + "/Api/V1/AdminCreditRule/List?";
	url = handleUrlEncode(url, param)
	return request({
		url: url,
		method: "get",
	});
}

/**
 * 后台积分规则更新
 * @param {Object} param
 */
export function updateCreditRule(data) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminCreditRule/Update",
		method: "post",
		data,
	});
}
